export default "__VITE_ASSET__Cz9$bw4r__";